import styled from "styled-components";

export const DisplayDate = styled.span`
    ${props => props.theme.fontStyles}
    color: inherit;
`
